import React from 'react';

import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const UserCounterSection: React.FC<{ sends: number; takes: number; totalCo2: string; hasCounter: boolean }> = ({ sends, takes, totalCo2, hasCounter }) => {
  const { t } = useTranslationContext(['common']);

  return (
    <section className="flex gap-3 max-lg:gap-2">
      <UserCounter count={sends} text={t('components.profile.public.sends', { ns: 'common' })} />
      <UserCounter count={takes} text={t('components.profile.public.takes', { ns: 'common' })} />
      {!hasCounter && (
        <UserCounter count={totalCo2} text={t('components.profile.public.co2', { ns: 'common' })} img={{ src: '/assets/leaf.png', alt: t('components.profile.public.alt-image', { ns: 'common' }) }} />
      )}
    </section>
  );
};

const UserCounter: React.FC<{ count: number | string; text: string; img?: { src: string; alt: string } }> = ({ count, text, img }) => {
  return (
    <div className="rounded-3 bg-bg-pale px-5 py-3 max-lg:rounded-2 max-lg:p-2">
      <div className="flex gap-4">
        <p className="text-title font-bold">{count}</p>
        {img && <img src={img.src} alt={img.alt} className="h-6 w-5 lg:h-9 lg:w-7" />}
      </div>
      <p className="text-caption-primary">{text}</p>
    </div>
  );
};
